module.exports = __webpack_public_path__ + "static/header-background-22d8bebaaa63f5b245524f878188ea47.jpg";